var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAlertWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2a2.795 2.795 0 0 1 2.367 1.298L23.56 17.7a2.807 2.807 0 0 1-2.368 4.319H2.808A2.808 2.808 0 0 1 .441 17.7L9.633 3.297A2.795 2.795 0 0 1 12 2zm0 17.595a1.53 1.53 0 1 1 0-3.06 1.53 1.53 0 0 1 0 3.06zm1.368-5.56.753-5.075a2.163 2.163 0 1 0-4.275.027l.82 5.066a1.368 1.368 0 0 0 2.702-.018z"
})));
export default SvgAlertWarning;